import { useFeeCalculator } from "@hooks/useFeeCalculator";
import { FeeCalculatorRenderConditions } from "@models/platform-analysis/entities/steps/fee";
import { memo, useRef } from "react";
import { evaluateRenderConditions } from "../../../utils";

export const FeeCalculatorVisibilityTracker = memo(
  ({
    renderConditions,
    invalidIfEmpty = false,
    onVisibilityChange,
  }: {
    renderConditions?: FeeCalculatorRenderConditions;
    invalidIfEmpty?: boolean;
    onVisibilityChange: (isVisible: boolean) => void;
  }) => {
    const editAnalysisFeeCalculatorHookValues = useFeeCalculator();
    const prevValueRef = useRef<boolean>();

    const shouldRenderSection = evaluateRenderConditions({
      conditions: renderConditions,
      values: editAnalysisFeeCalculatorHookValues,
      invalidIfEmpty,
    });

    if (prevValueRef.current !== shouldRenderSection) {
      prevValueRef.current = shouldRenderSection;
      onVisibilityChange(shouldRenderSection);
    }

    return <></>;
  },
);
